module.exports = __webpack_public_path__ + "media/images/aston-martin-0684d734ded9cf77314b487b76d4c5ad.svg";